import { render, staticRenderFns } from "./final-questions.vue?vue&type=template&id=c24e7f2a&scoped=true&"
import script from "./final-questions.vue?vue&type=script&lang=js&"
export * from "./final-questions.vue?vue&type=script&lang=js&"
import style0 from "./final-questions.vue?vue&type=style&index=0&id=c24e7f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24e7f2a",
  null
  
)

export default component.exports